import { api } from '@/services'

export function chargeSubscription(payload) {
  return api.post('web/open/charge/chargeSubscription', payload)
}

export const checkCharge = (chargeId) => {
  return api.get(`/web/open/charge/${chargeId}`)
}
